import React from 'react';
import { useRecoilValue } from 'recoil';
import { optionsState } from '../options';
import { truncate } from '../utils/truncate';
import { Value } from './Value';
import { Name } from './Name';
export function PlainObjectPreview(_ref) {
  let {
    data
  } = _ref;
  const {
    previewPropertiesMaxCount,
    previewStringMaxLength
  } = useRecoilValue(optionsState);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("i", null, `{`), Object.keys(data).slice(0, previewPropertiesMaxCount).map((k, i, arr) => /*#__PURE__*/React.createElement("i", {
    key: k
  }, /*#__PURE__*/React.createElement(Name, {
    data: k
  }), /*#__PURE__*/React.createElement("span", null, ":\xA0"), /*#__PURE__*/React.createElement(Value, {
    data: truncate(previewStringMaxLength)(data[k])
  }), i + 1 < arr.length ? ', ' : '')), Object.keys(data).length > previewPropertiesMaxCount && `, …`, /*#__PURE__*/React.createElement("i", null, `}`));
}